<template>
  <div class='table'>
    <el-table
      ref="singleTable"
      :data="tableData"
      highlight-current-row
      style="width: 100%"
      max-height="741"
    >
      <el-table-column
        fixed
        type="index"
        width="50"
        label="序号"
      >
      </el-table-column>
      <el-table-column
        :property="propertyData[0]"
        :label="labelData[0]"
        width="300"
      >
      </el-table-column>
      <el-table-column
        :label="labelData[1]"
        :property="propertyData[1]"
        width="200"
      >
      </el-table-column>
      <el-table-column
        :property="propertyData[2]"
        :label="labelData[2]"
        width="100"
      >
      </el-table-column>
      <el-table-column
        :property="propertyData[3]"
        :label="labelData[3]"
        width="200"
      >
      </el-table-column>
      <el-table-column
        :property="propertyData[4]"
        :label="labelData[4]"
        width="200"
      >
      </el-table-column>
      <el-table-column
        :property="propertyData[5]"
        :label="labelData[5]"
        width="200"
      >
      </el-table-column>
      <el-table-column
        :property="propertyData[6]"
        :label="labelData[6]"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        :property="propertyData[7]"
        :label="labelData[7]"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:right;margin-top:20px;"
      :hide-on-single-page="true"
      :total="total"
      :page-size="pagesize"
      :current-page='currentpage'
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
    >
    </el-pagination>
  </div>
</template>
<script>
import Api from '../api/index'

export default {
  data () {
    return {
      pagesize: 20,//每页显示数
      currentpage: 1,//当前页
    }
  },
  props: {
    labelData: Array,
    propertyData: Array,
    tableData: Array,
    total: Number,

  },
  methods: {
    handleCurrentChange (val) {
      this.currentpage = val;
      this.$emit('currentpage', val)
      this.$emit('GetDataList')
    }
  }
}
</script>
<style lang='less' scoped>
</style>